import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Alert, AlertTitle } from "~/atoms/alert";

interface Props {
  id: number;
  archivedAt: string | null;
}

export const ArchivedWarning = ({ id, archivedAt }: Props) => {
  const { t } = useTranslation();
  return (
    <Alert variant="warn" className="w-fit">
      <AlertTriangle />
      <AlertTitle>
        {archivedAt === null
          ? t(($) => $.commons.document.archivedVersionWarning)
          : t(($) => $.commons.document.archivedProject)}
        {archivedAt === null && (
          <Link to={`/documents/${id}`}>
            {" "}
            {t(($) => $.commons.document.goToLatestVersion)}
          </Link>
        )}
      </AlertTitle>
    </Alert>
  );
};
